import React from 'react';
import { motion } from 'framer-motion';
import { Phone } from 'lucide-react';

export default function CTABand() {
  const scrollToForm = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="bg-gradient-to-r from-[#1e3a5f] via-[#2d5a8f] to-[#1e3a5f] py-12 sm:py-16">
      <div className="mx-auto max-w-screen-xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center space-y-6 sm:space-y-8"
        >
          <div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3 sm:mb-4">
              Request A FREE Inspection
            </h2>
            <p className="text-base sm:text-xl md:text-2xl text-slate-200 px-4">
              Elite Roofing Are Your Trusted Roofing Contractors That Can Solve All Of Your Roofing Problems With Just One Call!
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center items-stretch sm:items-center px-4">
            <a 
              href="tel:+14077850642"
              className="inline-flex items-center justify-center gap-2 sm:gap-3 px-8 sm:px-10 py-4 sm:py-5 bg-[hsl(var(--accent))] hover:bg-[#a01830] text-white rounded-lg text-lg sm:text-2xl font-bold shadow-2xl transition-all hover:scale-105"
            >
              <Phone className="h-6 w-6 sm:h-7 sm:w-7" />
              (407) 785-0642
            </a>
            
            <button
              onClick={scrollToForm}
              className="px-8 sm:px-10 py-4 sm:py-5 bg-white hover:bg-slate-100 text-[hsl(var(--primary))] rounded-lg text-lg sm:text-2xl font-bold shadow-2xl transition-all hover:scale-105"
            >
              Schedule Online
            </button>
          </div>

          <div className="flex flex-wrap justify-center gap-4 sm:gap-6 text-slate-200 text-xs sm:text-sm px-4">
            <div className="flex items-center gap-2">
              <svg className="h-4 w-4 sm:h-5 sm:w-5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span>Free Inspections</span>
            </div>
            <div className="flex items-center gap-2">
              <svg className="h-4 w-4 sm:h-5 sm:w-5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span>Same-Day Response Available</span>
            </div>
            <div className="flex items-center gap-2">
              <svg className="h-4 w-4 sm:h-5 sm:w-5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span>Licensed & Insured</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}